module.exports = __webpack_public_path__ + "img/set_password.43fb893e.png";